'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = require('react');
var invariant = _interopDefault(require('tiny-invariant'));

var maxHorizontalScroll = function maxHorizontalScroll(dom) {
  return dom.scrollWidth - dom.clientWidth;
};

var maxVerticalScroll = function maxVerticalScroll(dom) {
  return dom.scrollHeight - dom.clientHeight;
};

var index = (function (domRef) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$onDragStart = _ref.onDragStart,
      onDragStart = _ref$onDragStart === void 0 ? function () {} : _ref$onDragStart,
      _ref$onDragEnd = _ref.onDragEnd,
      onDragEnd = _ref$onDragEnd === void 0 ? function () {} : _ref$onDragEnd,
      _ref$runScroll = _ref.runScroll,
      runScroll = _ref$runScroll === void 0 ? function (_ref2) {
    var dx = _ref2.dx,
        dy = _ref2.dy;
    var offsetX = Math.min(maxHorizontalScroll(domRef.current), domRef.current.scrollLeft + dx);
    domRef.current.scrollLeft = offsetX; // eslint-disable-line no-param-reassign

    var offsetY = Math.min(maxVerticalScroll(domRef.current), domRef.current.scrollTop + dy);
    domRef.current.scrollTop = offsetY; // eslint-disable-line no-param-reassign
  } : _ref$runScroll;

  var internalState = react.useRef({
    lastMouseX: null,
    lastMouseY: null,
    isMouseDown: false,
    isScrolling: false
  });
  var scroll = react.useCallback(function (_ref3) {
    var dx = _ref3.dx,
        dy = _ref3.dy;
    !(domRef.current !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Trying to scroll to the bottom, but no element was found.\n      Did you call this scrollBottom before the component with this hook finished mounting?") : invariant(false) : void 0;
    runScroll({
      dx: dx,
      dy: dy
    });
  }, [runScroll]);
  var onMouseDown = react.useCallback(function (e) {
    internalState.current.isMouseDown = true;
    internalState.current.lastMouseX = e.clientX;
    internalState.current.lastMouseY = e.clientY;
  }, []);

  var onMouseUp = function onMouseUp() {
    internalState.current.isMouseDown = false;
    internalState.current.lastMouseX = null;
    internalState.current.lastMouseY = null;

    if (internalState.current.isScrolling) {
      internalState.current.isScrolling = false;
      onDragEnd();
    }
  };

  var onMouseMove = function onMouseMove(e) {
    if (!internalState.current.isMouseDown) {
      return;
    }

    if (!internalState.current.isScrolling) {
      internalState.current.isScrolling = true;
      onDragStart();
    } // diff is negative because we want to scroll in the opposite direction of the movement


    var dx = -(e.clientX - internalState.current.lastMouseX);
    var dy = -(e.clientY - internalState.current.lastMouseY);
    internalState.current.lastMouseX = e.clientX;
    internalState.current.lastMouseY = e.clientY;
    scroll({
      dx: dx,
      dy: dy
    });
  };

  react.useEffect(function () {
    window.addEventListener('mouseup', onMouseUp);
    window.addEventListener('mousemove', onMouseMove);
    return function () {
      window.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, []);
  return {
    events: {
      onMouseDown: onMouseDown
    }
  };
});

exports.default = index;
